import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { HIDE_TOAST, ToastType } from '../../redux/reducers/toastReducer';

type BGType<K extends string> = Record<K, string>;

type ToastTypeKeys = ToastType['type'];

const bg: BGType<ToastTypeKeys> = {
  success: 'bg-green-500',
  error: 'bg-red-500',
  warning: 'bg-yellow-500',
  info: 'bg-blue-500',
};

function ToastMessage() {
  const toastState = useSelector((state: RootState) => state.toast);
  const dispatch = useDispatch<AppDispatch>();

  const hideToast = useCallback(() => {
    dispatch({ type: HIDE_TOAST });
  }, [dispatch]);

  useEffect(() => {
    if (toastState.interval && toastState.interval > 0) {
      setTimeout(() => {
        hideToast();
      }, toastState.interval);
    }
  }, [hideToast, toastState.interval, toastState.message]);

  if (!toastState.show) return null;
  return (
    <div
      className={`${
        bg[toastState.type]
      } border rounded py-1 flex justify-between items-center`}
    >
      <div className="px-1 w-full text-center">
        <p>{toastState.message}</p>
      </div>
      <div className="px-1">
        <button className="text-white mx-1" onClick={hideToast}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="black"
            className="w-4 h-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default ToastMessage;
